// @flow
import React from 'react'
import Checkbox from '../controls/Checkbox'
import type { LeadformCustomQuestion, LeadformStockQuestions } from '../types'
import styled, { type StyledComponent } from 'styled-components'
import _ from 'lodash'
import CustomQuestion from './CustomQuestion'

const Wrapper: StyledComponent<Object, any, any> = styled.div`
  padding: 8px 0;
`

const StockWrapper = styled.div`
  display: flex;
  align-items: left;
  flex-wrap: wrap;
`

const CheckboxWrapper = styled.div`
  display: inline-block;
  margin: 0 5px 3px 0;
`

const CustomQuestionBlock = styled.div`
  padding-bottom: 12px;
`

const CustomQuestionWrapper = styled.div`
  padding-left: 10px;
  border-left: solid 1px #ccc;
`

const Label = styled.div`
  display: inline-block;
  padding-bottom: 6px;
  font-size: 14px;
`

const Link = styled.a`
  font-size: 14px;
`

const t = {
  remove: 'удалить',
  name: 'Имя',
  patronymic: 'Отчество',
  surname: 'Фамилия',
  email: 'E-mail',
  phone: 'Телефон',
  age: 'Возраст',
  birthday: 'День рождения',
  location: 'Город',
  add_custom_question: '+ добавить вопрос',
  question: 'Вопрос'
}

export type Props = {|
  stockQuestions: LeadformStockQuestions,
  customQuestions: Array<LeadformCustomQuestion>,
  onStockQuestionsChange: (LeadformStockQuestions) => void,
  onCustomQuestionAdd: () => void,
  onCustomQuestionRemove: (index: number) => void,
  onCustomQuestionChange: (index: number, value: LeadformCustomQuestion) => void
|}

export default function Questions({
  stockQuestions,
  customQuestions,
  onStockQuestionsChange,
  onCustomQuestionAdd,
  onCustomQuestionRemove,
  onCustomQuestionChange
}: Props) {
  return (
    <Wrapper>
      <StockWrapper>
        <CheckboxWrapper>
          <Checkbox
            compact
            label={t.name}
            checked={stockQuestions.name}
            onChange={(value) => onStockQuestionsChange({ ...stockQuestions, name: value })}
          />
        </CheckboxWrapper>
        <CheckboxWrapper>
          <Checkbox
            compact
            label={t.patronymic}
            checked={stockQuestions.patronymic}
            onChange={(value) => onStockQuestionsChange({ ...stockQuestions, patronymic: value })}
          />
        </CheckboxWrapper>
        <CheckboxWrapper>
          <Checkbox
            compact
            label={t.surname}
            checked={stockQuestions.surname}
            onChange={(value) => onStockQuestionsChange({ ...stockQuestions, surname: value })}
          />
        </CheckboxWrapper>
        <CheckboxWrapper>
          <Checkbox
            compact
            label={t.email}
            checked={stockQuestions.email}
            onChange={(value) => onStockQuestionsChange({ ...stockQuestions, email: value })}
          />
        </CheckboxWrapper>
        <CheckboxWrapper>
          <Checkbox
            compact
            label={t.phone}
            checked={stockQuestions.phone}
            onChange={(value) => onStockQuestionsChange({ ...stockQuestions, phone: value })}
          />
        </CheckboxWrapper>
        <CheckboxWrapper>
          <Checkbox
            compact
            label={t.age}
            checked={stockQuestions.age}
            onChange={(value) => onStockQuestionsChange({ ...stockQuestions, age: value })}
          />
        </CheckboxWrapper>
        <CheckboxWrapper>
          <Checkbox
            compact
            label={t.birthday}
            checked={stockQuestions.birthday}
            onChange={(value) => onStockQuestionsChange({ ...stockQuestions, birthday: value })}
          />
        </CheckboxWrapper>
        <CheckboxWrapper>
          <Checkbox
            compact
            label={t.location}
            checked={stockQuestions.location}
            onChange={(value) => onStockQuestionsChange({ ...stockQuestions, location: value })}
          />
        </CheckboxWrapper>
      </StockWrapper>
      {_.map(customQuestions, (question: LeadformCustomQuestion, index: number) => {
        return (
          <CustomQuestionBlock className={`t-LeadformCustomQuestion_${index}`} key={index}>
            <Label>
              {t.question} {index + 1}
            </Label>
            <span> [</span>
            <Link
              href="#"
              onClick={(e) => {
                onCustomQuestionRemove(index)
                e.preventDefault()
              }}
            >
              {t.remove}
            </Link>
            <span>]</span>
            <CustomQuestionWrapper>
              <CustomQuestion data={question} onChange={(q) => onCustomQuestionChange(index, q)} />
            </CustomQuestionWrapper>
          </CustomQuestionBlock>
        )
      })}
      {customQuestions.length < 5 ? (
        <a
          href="#"
          onClick={(e) => {
            onCustomQuestionAdd()
            e.preventDefault()
          }}
        >
          {t.add_custom_question}
        </a>
      ) : null}
    </Wrapper>
  )
}
